import { createEntityAdapter } from '@reduxjs/toolkit';
import { Vehicle } from '../models/reservation.model';

const vehicleAdapter = createEntityAdapter<Vehicle>({
  selectId: (vehicle) => vehicle.vehicleID,
});

export { vehicleAdapter };
